export default (function (arr) {
    if (!arr || !arr.length) {
        return -1;
    }
    var minId = Math.min.apply(Math, arr.map(function (item) { return item.id; }));
    return Math.min(minId - 1, -1);
});
